var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "dropdown", class: { "is-active": _vm.isActive } },
    [
      _c("div", { staticClass: "dropdown-trigger" }, [
        _c(
          "button",
          {
            staticClass: "button is-dropdown",
            class: [_vm.buttonClassNames],
            attrs: {
              type: "button",
              "aria-haspopup": "true",
              disabled: _vm.disabled,
            },
            on: {
              click: function ($event) {
                _vm.isActive = !_vm.isActive
              },
            },
          },
          [_vm._m(0)]
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "dropdown-menu", attrs: { role: "menu" } }, [
        _c("div", { staticClass: "dropdown-content" }, [_vm._t("default")], 2),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("span", { staticClass: "icon" }, [_c("i")])
  },
]
render._withStripped = true

export { render, staticRenderFns }